module.exports = __webpack_public_path__ + "prof_icon.png?d112203e40c1c30b62103df700683bef";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/prof_icon.png
// module id = 52
// module chunks = 0